import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftControlPanel';

import { DraftStatus } from '../../model/draft';
import { Channel } from '../../model/skill';

const t = i18n(keyset);

type TextSet<TStatus extends string> = Record<TStatus, string>;
type TStatusKeys = Record<DraftStatus, '' | keyof (typeof keyset)['en']>;

const DEFAULT_STATUS_DESCRIPTION: TextSet<DraftStatus> = {
    [DraftStatus.InDevelopment]: t('desc-in-dev'),
    [DraftStatus.ReviewRequested]: t('desc-in-review'),
    [DraftStatus.ReviewApproved]: t('desc-approved'),
    [DraftStatus.DeployRequested]: t('desc-deploy'),
    [DraftStatus.ReviewCancelled]: '',
    [DraftStatus.ReviewRejected]: '',
    [DraftStatus.DeployRejected]: '',
    [DraftStatus.TestRequired]: '',
    [DraftStatus.MeetingApproval]: '',
    [DraftStatus.WaitingForTesting]: '',
    [DraftStatus.AppScanRequested]: t('desc-in-review'),
    [DraftStatus.AppScanRequestedAfterModeration]: t('desc-in-review'),
    [DraftStatus.DevicesTesting]: '',
    [DraftStatus.DevicesTestingCompleted]: '',
};

const DEFAULT_STATUS_DESCRIPTION_KEYS: TStatusKeys = {
    [DraftStatus.InDevelopment]: 'desc-in-dev',
    [DraftStatus.ReviewRequested]: 'desc-in-review',
    [DraftStatus.ReviewApproved]: 'desc-approved',
    [DraftStatus.DeployRequested]: 'desc-deploy',
    [DraftStatus.ReviewCancelled]: '',
    [DraftStatus.ReviewRejected]: '',
    [DraftStatus.DeployRejected]: '',
    [DraftStatus.TestRequired]: '',
    [DraftStatus.MeetingApproval]: '',
    [DraftStatus.WaitingForTesting]: '',
    [DraftStatus.AppScanRequested]: 'desc-in-review',
    [DraftStatus.AppScanRequestedAfterModeration]: 'desc-in-review',
    [DraftStatus.DevicesTesting]: '',
    [DraftStatus.DevicesTestingCompleted]: '',
};

const smartHomeDescriptions: TextSet<DraftStatus> = {
    ...DEFAULT_STATUS_DESCRIPTION,
    [DraftStatus.InDevelopment]: t('sh-desc-in-dev'),
    [DraftStatus.ReviewRequested]: t('sh-desc-in-review'),
    [DraftStatus.MeetingApproval]: t('sh-desc-meeting'),
    [DraftStatus.WaitingForTesting]: t('sh-desc-waiting-for-test'),
    [DraftStatus.DevicesTesting]: t('sh-desc-devices-testing'),
    [DraftStatus.DevicesTestingCompleted]: t('sh-desc-testing-complete'),
    [DraftStatus.ReviewApproved]: t('sh-desc-approved'),
};

export const smartHomeDescriptionsKeys: TStatusKeys = {
    ...DEFAULT_STATUS_DESCRIPTION_KEYS,
    [DraftStatus.InDevelopment]: 'sh-desc-in-dev',
    [DraftStatus.ReviewRequested]: 'sh-desc-in-review',
    [DraftStatus.MeetingApproval]: 'sh-desc-meeting',
    [DraftStatus.WaitingForTesting]: 'sh-desc-waiting-for-test',
    [DraftStatus.DevicesTesting]: 'sh-desc-devices-testing',
    [DraftStatus.DevicesTestingCompleted]: 'sh-desc-testing-complete',
    [DraftStatus.ReviewApproved]: 'sh-desc-approved',
};

export const skillDescriptions: Record<Channel, TextSet<DraftStatus>> = {
    [Channel.AliceSkill]: DEFAULT_STATUS_DESCRIPTION,
    [Channel.SmartHome]: smartHomeDescriptions,
    [Channel.Thereminvox]: DEFAULT_STATUS_DESCRIPTION,
    [Channel.TvApp]: DEFAULT_STATUS_DESCRIPTION,
    [Channel.AutoApp]: DEFAULT_STATUS_DESCRIPTION,
    [Channel.SmartScreenApp]: DEFAULT_STATUS_DESCRIPTION,
};

const aliceSkillDescriptionsAired: TextSet<DraftStatus> = {
    ...DEFAULT_STATUS_DESCRIPTION,
    [DraftStatus.DeployRequested]: t('aired-deploy'),
};

const tvAppDescriptionsAired: TextSet<DraftStatus> = {
    ...DEFAULT_STATUS_DESCRIPTION,
    [DraftStatus.DeployRequested]: t('aired-deploy'),
};

const smartHomeDescriptionsAired: TextSet<DraftStatus> = {
    ...DEFAULT_STATUS_DESCRIPTION,
    [DraftStatus.InDevelopment]: t('sh-desc-in-dev'),
    [DraftStatus.ReviewRequested]: t('sh-desc-in-review'),
    [DraftStatus.MeetingApproval]: t('sh-desc-meeting'),
    [DraftStatus.WaitingForTesting]: t('sh-desc-waiting-for-test'),
    [DraftStatus.DevicesTesting]: t('sh-desc-devices-testing'),
    [DraftStatus.DevicesTestingCompleted]: t('sh-desc-testing-complete'),
    [DraftStatus.ReviewApproved]: t('sh-desc-approved'),
};

export const smartHomeDescriptionsAiredKeys: TStatusKeys = {
    ...DEFAULT_STATUS_DESCRIPTION_KEYS,
    [DraftStatus.InDevelopment]: 'sh-desc-in-dev',
    [DraftStatus.ReviewRequested]: 'sh-desc-in-review',
    [DraftStatus.MeetingApproval]: 'sh-desc-meeting',
    [DraftStatus.WaitingForTesting]: 'sh-desc-waiting-for-test',
    [DraftStatus.DevicesTesting]: 'sh-desc-devices-testing',
    [DraftStatus.DevicesTestingCompleted]: 'sh-desc-testing-complete',
    [DraftStatus.ReviewApproved]: 'sh-desc-approved',
};

const thereminvoxDescriptionsAired: TextSet<DraftStatus> = {
    ...DEFAULT_STATUS_DESCRIPTION,
    [DraftStatus.DeployRequested]: t('aired-deploy'),
};

export const skillDescriptionsAired: Record<Channel, TextSet<DraftStatus>> = {
    [Channel.AliceSkill]: aliceSkillDescriptionsAired,
    [Channel.SmartHome]: smartHomeDescriptionsAired,
    [Channel.Thereminvox]: thereminvoxDescriptionsAired,
    [Channel.TvApp]: tvAppDescriptionsAired,
    [Channel.SmartScreenApp]: tvAppDescriptionsAired,
    [Channel.AutoApp]: tvAppDescriptionsAired,
};
